import * as React from "react";
const SvgFiRrElephant = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M22.995 16a1 1 0 0 0-1 1v2.899c0 .537-.364 1.015-.829 1.087a1 1 0 0 1-.804-.219 1 1 0 0 1-.348-.768V9.452c0-1.787-.889-3.462-2.401-4.509a6.006 6.006 0 0 0-6.746-3.838 5.97 5.97 0 0 0-3.35 1.896H6A6.005 6.005 0 0 0 0 9v11.002a3.003 3.003 0 0 0 6.005.008L6.008 19h4.019l-.002.995a2.98 2.98 0 0 0 .875 2.124c.566.568 1.32.881 2.122.881a3 3 0 0 0 2.998-2.998V19h1.995v.998a3.01 3.01 0 0 0 1.046 2.288c.542.464 1.23.713 1.941.713q.234 0 .471-.036c1.438-.224 2.522-1.541 2.522-3.063v-2.899a1 1 0 0 0-1-1.001m-7.976 1a1 1 0 0 0-1 1v2.002a.999.999 0 0 1-1.704.705 1 1 0 0 1-.291-.707l.005-1.998a.997.997 0 0 0-1-1.002h-6.02a1 1 0 0 0-1 .998l-.005 2.007A1 1 0 0 1 2.997 21a1 1 0 0 1-.998-.998V9c0-2.206 1.794-4 4-4h.334q-.121.344-.197.704c-.383 1.812.056 3.661 1.201 5.073A5.98 5.98 0 0 0 11.999 13a1 1 0 1 0 0-2A3.99 3.99 0 0 1 8.89 9.517c-.775-.956-1.058-2.164-.797-3.4.109-.514.804-2.424 3.137-3.045 1.927-.513 3.819.688 4.504 2.559.148.405.416.748.771.99a3.46 3.46 0 0 1 1.509 2.883v7.498h-2.995z"
    />
  </svg>
);
export default SvgFiRrElephant;
